<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-md-4 content-container">
            <router-link :to="{ name: 'Home' }">
              <v-btn color="primary-dark" density="compact" variant="default" size="small">
                <v-icon icon="mdi-arrow-left-bold"></v-icon>
                Retour à l'accueil
              </v-btn>
            </router-link>
            <div v-if="mainStore.authUser.isLogged">
              <FicheCoureur></FicheCoureur>
            </div>
            <div v-else>
              <v-container>
                <v-row>
                  <v-col>
                    <div class="mt-3">
                      <p>Depuis votre fiche coureur, vous pouvez administrer les inscriptions de vos coureurs au module.
                      </p>
                      <p>Modifier une inscription (changer de parcours, transfert de dossards, ajout de documents
                        manquants etc.)</p>
                      <p class="text-h6">Pour cela, veuillez vous connecter via le formulaire ci-contre
                        <v-icon>mdi-arrow-right</v-icon>
                      </p>
                    </div>
                  </v-col>
                  <v-col md="6" cols="12">
                    <LoginForm class="pa-2 bordered rounded"></LoginForm>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import LoginForm from "@/components/Authentification/LoginForm.vue";
import FicheCoureur from "@/components/FicheCoureur/Fiche_Coureur.vue";
export default {
  components: { LoginForm, FicheCoureur },
  data() {
    return {
      error: "",
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },

  async mounted() {
    if (!this.$route.query.auth) {
      return;
    }
    this.mainStore.authUser.logout();
    const authToken = this.$route.query.auth;
    let request = await this.mainStore.authUser.loginWithAuthToken(authToken);

    if (request.success) {
      this.$router.replace({ query: null });
      this.mainStore.notification.send("Connexion réussie au compte de " + request.user.mail, "success");
    } else {
      this.mainStore.notification.send(request.error, "error");
    }
  },
};
</script>

<style lang="scss" scoped></style>